import { format } from "date-fns";

export const DRUG_TEST_COLUMNS = [
  {
    Header: "Batch No",
    accessor: "BatchNo",
    id: "BatchNo"
  },

  {
    Header: "Employee",
    accessor: "EmployeeFullName",
    id: "EmployeeName"
  },
  {
    Header: "Description",
    accessor: "DrugTestCategoryDesc",
    id: "Description"
  },
  {
    Header: "Selection Date",
    accessor: "SelectionDate",
    id: "SelectionDate",
    Cell: ({ cell }) =>
      cell.value ? format(new Date(cell.value), "MM/dd/yyyy") : null
  },
  {
    Header: "Test Site",
    accessor: "TestSiteCodeDescription",
    id: "TestSite"
  },
  {
    Header: "Disposition",
    accessor: "Disposition",
    id: "TestDisposition"
  },
  {
    Header: "Drug Result",
    accessor: "DrugTestResult",
    id: "DrugTestResult"
  },
  {
    Header: "Alcohol Result",
    accessor: "AlcoholTestResult",
    id: "AlcoholTestResult"
  },
  {
    Header: "Comment",
    accessor: "Comment",
    id: "Comment"
  },
  {
    Header: "Active",
    accessor: "Status",
    id: "Status"
  }
];
